import axios, { AxiosError } from "axios";
import { baseUrl } from "./config";

export const api = axios.create({
  headers: { Accept: "application/json" },
  withCredentials: true,
  baseURL: baseUrl,
});

let unauthorizedHandler: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: (() => void) | null) => {
  unauthorizedHandler = handler;
};

export const getUnauthorizedHandler = () => unauthorizedHandler;

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      unauthorizedHandler?.();
    }
    return Promise.reject(error);
  }
);